import common from '@/validator/CommonRules'

/**
 * 注文時レコメンド バリデーションルール
 */
export default {
  shops: 'required',
  order: 'required',
  recommend: 'required',
  startAt: common.requiredDateRule + '|before:endAt',
  endAt: common.requiredDateRule + '|after:startAt',
}
